const unorm = require("unorm");

module.exports.slugify = str =>
  unorm.nfd(str.toLowerCase())
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ +/g, "-")
    .replace(/[\(\)–]/g, "-");
